import React, { useState, useEffect } from 'react';
import useNotificationStore from '../stores/useNotificationStore';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../stores/useAuthStore';

const NotificationBell = () => {
    const navigate = useNavigate();
    const user = useAuthStore(state => state.user);
    const { unreadCount, fetchNotifications } = useNotificationStore();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        fetchNotifications({ limit: 5 });
    }, []);

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="p-1 text-neutral-500 hover:text-neutral-700 dark:text-neutral-400 dark:hover:text-neutral-300 relative"
            >
                <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                    />
                </svg>
                {unreadCount > 0 && (
                    <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>
                )}
            </button>

            {isOpen && (
                <div className="absolute right-0 mt-2 w-80 bg-white dark:bg-neutral-800 rounded-lg shadow-lg border border-neutral-200 dark:border-neutral-700 z-50">
                    <div className="p-4 border-b border-neutral-200 dark:border-neutral-700 flex justify-between items-center">
                        <h3 className="font-medium text-neutral-900 dark:text-white">Notifications</h3>
                        <button
                            onClick={() => {
                                useNotificationStore.getState().markAllAsRead();
                                setIsOpen(false);
                            }}
                            className="text-sm text-primary-600 hover:text-primary-800 dark:text-primary-400"
                        >
                            Mark all as read
                        </button>
                    </div>
                    <div className="max-h-96 overflow-y-auto">
                        {useNotificationStore.getState().notifications.length === 0 ? (
                            <div className="p-4 text-center text-neutral-500 dark:text-neutral-400">
                                No notifications
                            </div>
                        ) : (
                            useNotificationStore.getState().notifications.slice(0, 5).map(notification => (
                                <div
                                    key={notification._id}
                                    onClick={() => {
                                        useNotificationStore.getState().markAsRead(notification._id);
                                        setIsOpen(false);
                                        if (notification.type === 'course_enrolled' || notification.type === 'course_approved' || notification.type === 'course_rejected') {
                                            if (user.role === 'admin') {
                                                navigate('/admin/cloud/notifications');
                                            } else if (user.role === 'instructor') {
                                                navigate('/instructor/my-courses');
                                            } else if (user.role === 'student') {
                                                navigate('/student/my-courses');
                                            } else {
                                                navigate('/');
                                            } 
                                        } else if (notification.type === 'badge_earned') {
                                            navigate('/student/achivements');
                                        } else if (notification.type === 'certificate_issued') {
                                            navigate(`/student/course/${notification.relatedId}/certificate`);
                                        } else if (notification.type === 'partner_program') {
                                            if (user.role === 'admin') {
                                                navigate('/admin/cloud/partners');
                                            } else if (user.role === 'instructor') {
                                                navigate('/instructor/partnerprogram');
                                            } else {
                                                navigate('/');
                                            } 
                                        } else {
                                            if (user.role === 'admin') {
                                                navigate('/admin/cloud/notifications');
                                            } else if (user.role === 'instructor') {
                                                navigate('/instructor/notifications');
                                            } else if (user.role === 'student') {
                                                navigate('/student/notifications');
                                            } else {
                                                navigate('/');
                                            }
                                        }
                                    }}
                                    className={`p-4 border-b border-neutral-200 dark:border-neutral-700 cursor-pointer hover:bg-neutral-50 dark:hover:bg-neutral-700/50 ${!notification.isRead ? 'bg-primary-50 dark:bg-primary-900/10' : ''
                                        }`}
                                >
                                    <p className="text-sm text-neutral-900 dark:text-white">{notification.message}</p>
                                    <p className="text-xs text-neutral-500 dark:text-neutral-400 mt-1">
                                        {new Date(notification.createdAt).toLocaleDateString()}
                                    </p>
                                </div>
                            ))
                        )}
                    </div>
                    <div className="p-2 text-center">

                        {user?.role === "instructor" && (
                            <button
                                onClick={() => navigate('/instructor/notifications')}
                                className="text-sm text-primary-600 hover:text-primary-800 dark:text-primary-400"
                            >
                                View all notifications
                            </button>
                        )}

                        {user?.role === "student" && (
                            <button
                                onClick={() => navigate('/student/notifications')}
                                className="text-sm text-primary-600 hover:text-primary-800 dark:text-primary-400"
                            >
                                View all notifications
                            </button>
                        )}

                        {user?.role === "admin" && (
                            <button
                                onClick={() => navigate('/admin/cloud/notifications')}
                                className="text-sm text-primary-600 hover:text-primary-800 dark:text-primary-400"
                            >
                                View all notifications
                            </button>
                        )}

                    </div>
                </div>
            )}
        </div>
    );
};

export default NotificationBell;